<template>
  <div>
    <transition name="custom-fade">
      <div
        v-if="localOpen && backdrop"
        class="position-fixed top-0 right-0 bottom-0 left-0"
        :style="{zIndex: zIndex}"  
        @click="close()"
      >
      <div class="bg-dark h-100 w-100 opacity-5"></div>
    </div>
    </transition>
    <transition name="custom-slide">
      <div
        v-if="localOpen"
        class="bg-white position-fixed top-0 right-0 bottom-0 p-4 shadow-lg "
        :style="{
          zIndex: zIndex,
          borderRadius: '0.4375rem 0 0 0.4375rem',
          overflowY: 'auto',
          width: width,
          maxWidth: maxWidth,
        }"
        tabindex="0"
      >
      <div class="position-absolute top-0 right-0 p-3">
        <i class="fa fa-times close-button p-2" @click="close"></i>
      </div>
      <div>
        <slot></slot>
      </div>
      </div>

    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      localOpen: this.open,
    };
  },
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    backdrop: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "25%",
    },
    maxWidth: {
      type: String,
      default: "100%",
    },
    zIndex: {
      type: Number,
      default: 1051,
    },
  },
  watch: {
    localOpen(newValue) {
      this.$emit("update:open", newValue);
    },
    open(newValue) {
      this.localOpen = newValue;
    },
  },
  methods: {
    close() {
      this.$emit("update:open", false);
      this.$emit("close");
    },
  },
};
</script>

<style scoped>

.close-button {
  cursor: pointer;
  color: #ced4da;
}
.close-button:hover {
  color: #8898aa;
}
</style>

<style>
/* Fade transitions */
.custom-fade-enter-active,
.custom-fade-leave-active {
  transition: opacity 300ms ease-in-out;
}
.custom-fade-enter, .custom-fade-leave-to {
  opacity: 0;
}
.custom-fade-enter-to, .custom-fade-leave {
  opacity: 1;
}

/* Slide transitions */
.custom-slide-enter-active,
.custom-slide-leave-active {
  transition: transform 300ms ease-in-out;
}
.custom-slide-enter, .custom-slide-leave-to {
  transform: translateX(100%);
}
.custom-slide-enter-to, .custom-slide-leave {
  transform: translateX(0);
}

</style>